(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[96419],{

/***/ 79228:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_TextField; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/autosize/dist/autosize.esm.js
var autosize_esm = __webpack_require__(3682);
// EXTERNAL MODULE: ./UI/components/TextField/styles.module.scss
var styles_module = __webpack_require__(91979);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/components/TextField/utils/useProps.js








/* harmony default export */ function useProps(props) {
    var textarea = props.textarea, style = props.style, classNameProp = props.className, errorMessage = props.errorMessage, attached = props.attached, register = props.register, name = props.name, placeholder = props.placeholder, type = props.type, required = props.required, minLength = props.minLength, maxLength = props.maxLength, rows = props.rows, restProps = (0,_object_without_properties/* default */.Z)(props, [
        "textarea",
        "style",
        "className",
        "errorMessage",
        "attached",
        "register",
        "name",
        "placeholder",
        "type",
        "required",
        "minLength",
        "maxLength",
        "rows"
    ]);
    var Component = textarea ? "textarea" : "input";
    var inputRef = (0,react.useRef)(null);
    var inputRegister = register && register(name, {
        required: required,
        pattern: {
            value: type === "email" && /\S+@\S+\.\S+/
        },
        minLength: minLength,
        maxLength: maxLength
    });
    var _obj;
    var className = classnames_default()(classNameProp, (styles_module_default()).input, (_obj = {}, (0,_define_property/* default */.Z)(_obj, (styles_module_default())[style], style), (0,_define_property/* default */.Z)(_obj, (styles_module_default()).attached, attached), _obj));
    var options = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps, inputRegister), {
        required: required,
        placeholder: placeholder,
        type: type,
        tabIndex: "0",
        rows: rows || 1,
        ref: register ? function(el) {
            inputRegister.ref(el);
            inputRef.current = el;
        } : inputRef
    });
    (0,react.useEffect)(function() {
        if (textarea && inputRef && (inputRef === null || inputRef === void 0 ? void 0 : inputRef.current)) (0,autosize_esm/* default */.Z)(inputRef === null || inputRef === void 0 ? void 0 : inputRef.current);
    }, [
        textarea
    ]);
    return {
        Component: Component,
        className: className,
        options: options,
        errorMessage: errorMessage
    };
};

;// CONCATENATED MODULE: ./UI/components/TextField/index.jsx





var TextField = function(props) {
    var ref = useProps(props), Component = ref.Component, className = ref.className, options = ref.options, errorMessage = ref.errorMessage;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: className,
        role: "textbox",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, (0,_object_spread/* default */.Z)({}, options)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (styles_module_default()).error,
                tabIndex: "-1",
                children: errorMessage
            })
        ]
    });
};
TextField.defaultProps = {
    type: "text",
    errorMessage: "Fill empty field"
};
TextField.propTypes = {
    register: (prop_types_default()).func,
    onChange: (prop_types_default()).func,
    value: (prop_types_default()).func,
    style: (prop_types_default()).string,
    textarea: (prop_types_default()).bool,
    required: (prop_types_default()).bool,
    type: (prop_types_default()).string,
    name: (prop_types_default()).string,
    placeholder: (prop_types_default()).string.isRequired,
    className: (prop_types_default()).string,
    pattern: (prop_types_default()).string,
    errorMessage: (prop_types_default()).string,
    attached: (prop_types_default()).bool,
    minLength: (prop_types_default()).number,
    maxLength: (prop_types_default()).number
};
/* harmony default export */ var components_TextField = (TextField);


/***/ }),

/***/ 94813:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ getPersonCountry; }
/* harmony export */ });
/* unused harmony export sendDataPipedrive */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(29815);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97582);
/* harmony import */ var dotenv__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59015);
/* harmony import */ var dotenv__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(dotenv__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var cookies_next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47041);
/* harmony import */ var cookies_next__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(cookies_next__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _error__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93250);
/* provided dependency */ var process = __webpack_require__(34155);









dotenv__WEBPACK_IMPORTED_MODULE_0___default().config("./env");
var getPipedriveFields = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
        var ref, pipedriveFields, countryField, cityRegionField, clientIdField, leadSourceField, leadTypeField, campaignField, phoneField, attachmentsField, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        axios__WEBPACK_IMPORTED_MODULE_1___default().get("".concat(process.env.PIPEDRIVE_API_URL, "/personFields?api_token=").concat(process.env.PIPEDRIVE_AUTH_TOKEN))
                    ];
                case 1:
                    ref = _state.sent(), pipedriveFields = ref.data;
                    countryField = pipedriveFields.data.find(function(field) {
                        return field.name === "Person Country" && (field === null || field === void 0 ? void 0 : field.id) === 9094;
                    });
                    cityRegionField = pipedriveFields.data.find(function(field) {
                        return field.name === "Person City/State" && (field === null || field === void 0 ? void 0 : field.id) === 9093;
                    });
                    clientIdField = pipedriveFields.data.find(function(field) {
                        return field.name.trim() === "Client ID" && (field === null || field === void 0 ? void 0 : field.id) === 9086;
                    });
                    leadSourceField = pipedriveFields.data.find(function(field) {
                        return field.name === "Lead source" && (field === null || field === void 0 ? void 0 : field.id) === 9087;
                    });
                    leadTypeField = pipedriveFields.data.find(function(field) {
                        return field.name === "Lead type" && (field === null || field === void 0 ? void 0 : field.id) === 9089;
                    });
                    campaignField = pipedriveFields.data.find(function(field) {
                        return field.name === "Web page / UTM" && (field === null || field === void 0 ? void 0 : field.id) === 9107;
                    });
                    phoneField = pipedriveFields.data.find(function(field) {
                        return field.name === "Phone" && (field === null || field === void 0 ? void 0 : field.id) === 9041;
                    });
                    attachmentsField = pipedriveFields.data.find(function(field) {
                        return field.name === "Attachments" && (field === null || field === void 0 ? void 0 : field.id) === 9108;
                    });
                    return [
                        2,
                        {
                            countryField: countryField,
                            cityRegionField: cityRegionField,
                            clientIdField: clientIdField,
                            leadSourceField: leadSourceField,
                            phoneField: phoneField,
                            leadTypeField: leadTypeField,
                            campaignField: campaignField,
                            attachmentsField: attachmentsField
                        }
                    ];
                case 2:
                    error = _state.sent();
                    (0,_error__WEBPACK_IMPORTED_MODULE_5__/* .handleError */ .S3)({
                        error: error,
                        message: "Error in the getPipedriveFields function"
                    });
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function getPipedriveFields() {
        return _ref.apply(this, arguments);
    };
}();
var createPersonPipedrive = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(data) {
        var clientIdFieldKey, leadSourceFieldKey, countryFieldKey, clientCountry, email, name, phoneFieldKey, phone, clientId, leadSourceOptionId, cityRegionField, clientCityRegion, leadTypeOptionId, leadTypeFieldKey, campaignFieldKey, clientCampaign, _obj, ref, newPersonPipedrive, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    clientIdFieldKey = data.clientIdFieldKey, leadSourceFieldKey = data.leadSourceFieldKey, countryFieldKey = data.countryFieldKey, clientCountry = data.clientCountry, email = data.email, name = data.name, phoneFieldKey = data.phoneFieldKey, phone = data.phone, clientId = data.clientId, leadSourceOptionId = data.leadSourceOptionId, cityRegionField = data.cityRegionField, clientCityRegion = data.clientCityRegion, leadTypeOptionId = data.leadTypeOptionId, leadTypeFieldKey = data.leadTypeFieldKey, campaignFieldKey = data.campaignFieldKey, clientCampaign = data.clientCampaign;
                    return [
                        4,
                        axios__WEBPACK_IMPORTED_MODULE_1___default().post("".concat(process.env.PIPEDRIVE_API_URL, "/persons?api_token=").concat(process.env.PIPEDRIVE_AUTH_TOKEN), (_obj = {
                            name: name,
                            email: [
                                {
                                    value: email,
                                    primary: "true",
                                    label: "main"
                                }
                            ],
                            phone: [
                                {
                                    value: phone,
                                    primary: "true",
                                    label: "main"
                                }
                            ]
                        }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, clientIdFieldKey, clientId), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, leadSourceFieldKey, leadSourceOptionId || ""), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, countryFieldKey, clientCountry || ""), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, phoneFieldKey, phone || ""), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, cityRegionField, clientCityRegion), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, leadTypeFieldKey, leadTypeOptionId), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, campaignFieldKey, clientCampaign), _obj))
                    ];
                case 1:
                    ref = _state.sent(), newPersonPipedrive = ref.data;
                    return [
                        2,
                        newPersonPipedrive
                    ];
                case 2:
                    error = _state.sent();
                    (0,_error__WEBPACK_IMPORTED_MODULE_5__/* .handleError */ .S3)({
                        error: error,
                        message: "Error in the createPersonPipedrive function"
                    });
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function createPersonPipedrive(data) {
        return _ref.apply(this, arguments);
    };
}();
var createDescriptionPerson = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(data) {
        var personId, description, ownerId, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    personId = data.personId, description = data.description, ownerId = data.ownerId;
                    return [
                        4,
                        axios__WEBPACK_IMPORTED_MODULE_1___default().post("".concat(process.env.PIPEDRIVE_API_URL, "/notes?api_token=").concat(process.env.PIPEDRIVE_AUTH_TOKEN), {
                            person_id: personId,
                            content: description,
                            user_id: ownerId
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
                case 2:
                    error = _state.sent();
                    (0,_error__WEBPACK_IMPORTED_MODULE_5__/* .handleError */ .S3)({
                        error: error,
                        message: "Error in the createDescriptionPerson function"
                    });
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function createDescriptionPerson(data) {
        return _ref.apply(this, arguments);
    };
}();
var findCurrentOption = function(options, currentSource) {
    return options.find(function(field) {
        return (currentSource === null || currentSource === void 0 ? void 0 : currentSource.trim().toLowerCase()) === field.label.trim().toLowerCase();
    });
};
var getCurrentLeadSourceOption = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(param) {
        var leadSourceFieldsOptions, currentSource, leadSourceField, leadSourceOptions, data, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    leadSourceFieldsOptions = param.leadSourceFieldsOptions, currentSource = param.currentSource, leadSourceField = param.leadSourceField;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    leadSourceOptions = findCurrentOption(leadSourceFieldsOptions, currentSource);
                    if (!(!leadSourceOptions && currentSource)) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        axios__WEBPACK_IMPORTED_MODULE_1___default().put("".concat(process.env.PIPEDRIVE_API_URL, "/personFields/").concat(leadSourceField.id, "?api_token=").concat(process.env.PIPEDRIVE_AUTH_TOKEN), {
                            options: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(leadSourceFieldsOptions).concat([
                                {
                                    label: currentSource
                                }
                            ])
                        })
                    ];
                case 2:
                    data = _state.sent().data;
                    leadSourceOptions = findCurrentOption(data.data.options, currentSource);
                    _state.label = 3;
                case 3:
                    return [
                        2,
                        leadSourceOptions
                    ];
                case 4:
                    error = _state.sent();
                    (0,_error__WEBPACK_IMPORTED_MODULE_5__/* .handleError */ .S3)({
                        error: error,
                        message: "Error in the getCurrentLeadSourceOption function"
                    });
                    return [
                        3,
                        5
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return function getCurrentLeadSourceOption(_) {
        return _ref.apply(this, arguments);
    };
}();
var getPersonCountry = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
        var data, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        axios__WEBPACK_IMPORTED_MODULE_1___default().get("https://ipapi.co/json/")
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
                case 2:
                    error = _state.sent();
                    (0,_error__WEBPACK_IMPORTED_MODULE_5__/* .handleError */ .S3)({
                        error: error,
                        message: "Error in the getPersonCountry function"
                    });
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function getPersonCountry() {
        return _ref.apply(this, arguments);
    };
}();
function sendDataPipedrive(req, res) {
    return _sendDataPipedrive.apply(this, arguments);
}
function _sendDataPipedrive() {
    _sendDataPipedrive = _async_to_generator(function(req, res) {
        var _body, name, email, phone, description, clientId, source, medium, city, clientCityRegion, clientCountry, leadSource, fieldData, countryField, cityRegionField, clientIdField, leadSourceField, phoneField, leadTypeField, campaignField, leadSourceOptions, leadTypeOption, data, ref, error;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        6,
                        ,
                        7
                    ]);
                    _body = req.body, name = _body.name, email = _body.email, phone = _body.phone, description = _body.description, clientId = _body.clientId, source = _body.source, medium = _body.medium, city = _body.city, clientCityRegion = _body.clientCityRegion, clientCountry = _body.clientCountry;
                    leadSource = JSON.parse(getCookie(leadSourceCookieName, {
                        req: req,
                        res: res
                    }));
                    return [
                        4,
                        getPipedriveFields()
                    ];
                case 1:
                    fieldData = _state.sent();
                    countryField = fieldData.countryField, cityRegionField = fieldData.cityRegionField, clientIdField = fieldData.clientIdField, leadSourceField = fieldData.leadSourceField, phoneField = fieldData.phoneField, leadTypeField = fieldData.leadTypeField, campaignField = fieldData.campaignField;
                    return [
                        4,
                        getCurrentLeadSourceOption({
                            leadSourceFieldsOptions: leadSourceField.options,
                            currentSource: "".concat(source, "/").concat(medium),
                            leadSourceField: leadSourceField
                        })
                    ];
                case 2:
                    leadSourceOptions = _state.sent();
                    leadTypeOption = findCurrentOption(leadTypeField.options, "Inbound");
                    return [
                        4,
                        createPersonPipedrive({
                            clientIdFieldKey: clientIdField.key,
                            leadSourceFieldKey: leadSourceField.key,
                            countryFieldKey: countryField.key,
                            cityRegionField: cityRegionField.key,
                            phoneFieldKey: phoneField.key,
                            leadTypeFieldKey: leadTypeField.key,
                            campaignFieldKey: campaignField.key,
                            clientId: clientId,
                            name: name,
                            email: email,
                            phone: phone,
                            city: city,
                            clientCityRegion: clientCityRegion,
                            clientCountry: clientCountry,
                            leadSourceOptionId: leadSourceOptions === null || leadSourceOptions === void 0 ? void 0 : leadSourceOptions.id,
                            leadTypeOptionId: leadTypeOption === null || leadTypeOption === void 0 ? void 0 : leadTypeOption.id,
                            clientCampaign: leadSource.campaign
                        })
                    ];
                case 3:
                    data = _state.sent().data;
                    if (!data) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        createDescriptionPerson({
                            personId: data === null || data === void 0 ? void 0 : data.id,
                            ownerId: data === null || data === void 0 ? void 0 : (ref = data.owner_id) === null || ref === void 0 ? void 0 : ref.id,
                            description: description
                        })
                    ];
                case 4:
                    _state.sent();
                    return [
                        2,
                        data
                    ];
                case 5:
                    return [
                        3,
                        7
                    ];
                case 6:
                    error = _state.sent();
                    handleError({
                        error: error,
                        message: "Error in the sendDataPipedrive function"
                    });
                    res.status(500).json({
                        error: error.message
                    });
                    return [
                        3,
                        7
                    ];
                case 7:
                    return [
                        2
                    ];
            }
        });
    });
    return _sendDataPipedrive.apply(this, arguments);
}


/***/ }),

/***/ 91979:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"input":"styles_input__B8LQP","error":"styles_error__6v2ur","attached":"styles_attached__j_Fm3"};

/***/ }),

/***/ 76647:
/***/ (function() {

/* (ignored) */

/***/ })

}]);